import React from 'react';
import { InputFieldProps } from '../types';

export const InputField: React.FC<InputFieldProps> = ({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  title,
  pattern,
  autoComplete = 'off',
  className = '',
  containerClassName = '',
  fontSize = 'text-s-14',
}) => {
  return (
    <div className={`py-2 ${containerClassName}`}>
      <label
        htmlFor={id}
        className={`${fontSize} font-medium pb-1 leading-[24px] sm:leading-[22px]`}
      >
        {label}
      </label>
      <br />
      <input
        className={`${fontSize} font-medium text-grey-500 w-full px-4 pt-3 pb-3 rounded-sm border border-gray-200 bg-grey-100 ${className}`}
        type={type}
        id={id}
        placeholder={placeholder}
        required={required}
        title={title}
        pattern={pattern}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
      />
      <p id={`${id}_error_message`} className="text-s-14 text-red-350"></p>
    </div>
  );
};
